import { useEffect, useState } from "react"
import { EnkIWPServerAuth as ApiAuth } from "../api/api-iwp-server"
import EnkContentLoadingAndError from "../components/error-box"

export default function EnkDashboard() {
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [welkomContent, setWelkomContent] = useState<string>("")

  const getWelcomePage = async () => {
    try {
      const html = await ApiAuth.getWelcomePage()
      setWelkomContent(html)
      setLoading(false)
    } catch (error) {
      console.error("Error fetching welkom content:", error)
      setError("Er is een fout opgetreden bij het ophalen van de welkomspagina.")
    }
  }
  useEffect(() => {
    // Fetch the partial HTML content
    void getWelcomePage()
  }, [])

  return (
    <EnkContentLoadingAndError loading={loading} error={error}>
      <div dangerouslySetInnerHTML={{ __html: welkomContent }} />
    </EnkContentLoadingAndError>
  )
}
